var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_681",
    "data-name": "Group 681",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(9 9)",
    strokeWidth: 2,
    stroke: "#b6b6c7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M19.4,15a1.656,1.656,0,0,0,.33,1.82l.06.06a2,2,0,0,1,0,2.83h0a2,2,0,0,1-2.83,0h0l-.06-.06a1.663,1.663,0,0,0-2.82,1.18V21a2,2,0,0,1-4,0v-.09A1.643,1.643,0,0,0,9,19.4a1.656,1.656,0,0,0-1.82.33l-.06.06a2,2,0,0,1-2.83,0h0a2,2,0,0,1,0-2.83h0l.06-.06a1.663,1.663,0,0,0-1.18-2.82H3a2,2,0,0,1,0-4h.09A1.643,1.643,0,0,0,4.6,9a1.656,1.656,0,0,0-.33-1.82l-.06-.06a2,2,0,0,1,0-2.83h0a2,2,0,0,1,2.83,0h0l.06.06a1.656,1.656,0,0,0,1.82.33H9a1.651,1.651,0,0,0,1-1.51V3a2,2,0,0,1,4,0v.09a1.663,1.663,0,0,0,2.82,1.18l.06-.06a2,2,0,0,1,2.83,0h0a2,2,0,0,1,0,2.83h0l-.06.06a1.656,1.656,0,0,0-.33,1.82V9a1.651,1.651,0,0,0,1.51,1H21a2,2,0,0,1,0,4h-.09A1.651,1.651,0,0,0,19.4,15Z",
    fill: "none",
    stroke: "#b6b6c7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerAccount);
export default __webpack_public_path__ + "static/media/drawer-account.ab0c3dcd343367a7277e0887eb855e95.svg";
export { ForwardRef as ReactComponent };